import { AppStrings } from './base-strings';

export const zh: AppStrings = {
  APP: {
    locale: 'zh-TW',
    lang: '正體中文',
    confirmed: '確診',
    forest: '森林',
    colon: '：',
    introTitle: ['不管是放心還是擔心', '能夠掌握身邊狀況是最好的'].join('\n'),
    introBody: [
      '使用確診森林™紀錄自己的接觸者',
      '就能看出疾病距離你多遠',
      '需要經過多少層接觸',
      '並做好對應的防疫措施👍🏻👍🏻',
    ].join('\n'),
    hint: [
      '確診森林™的目標是希望幫助政府和民眾，能夠更快速地追蹤疫情來源，透過輸入手機號碼登入我們的系統，並且新增曾和自己近距離接觸（未保持社交距離）的身分證帳號，我們能幫你統計出三度內接觸者的可能症狀。',
      '＊所有個資僅供個人統計、追蹤和自己健康管理提醒用途。',
    ].join('\n'),
    contactUs: '聯絡我們',
  },
  LOGIN_SECTION: {
    hint: [
      '手機號碼只用來紀錄自身情況與加入接觸者。',
      '＊注意：請勿擅自使用他人手機號碼，避免造謠嫌疑。',
    ].join('\n'),
    title: '請輸入你的手機號碼',
    label: '手機號碼',
    placeholder: '輸入手機號碼',
    emptyWarning: '你必需輸入你自己的手機號碼',
    invalidWarning: '你必需輸入合法的手機號碼',
    dialogAlertTitle: '我們正在取得你的個人資訊⋯⋯',
    dialogAlertDescription: '請稍等，謝謝你的耐心等候。',
  },
  SYMPTOM_SECTION: {
    hint: [
      '輸入你目前擁有的症狀，若無症狀，以下請留白。',
      '別擔心，別人無法看到你擁有哪些症況。',
      '這些資訊只會出現在加總統計當中，以幫助大家瞭解接觸史風險，為己為人。',
    ].join('\n'),
    title: '你的症狀',
    warning: '你必需選擇一個以上的症狀',
  },
  SYMPTOM: {
    confirmed: '確診新冠肺炎',
    cough: '咳嗽',
    difficultyBreathing: '呼吸困難',
    fever: '發燒',
    musclePain: '肌肉痠痛',
    newLossOfTasteOrSmell: '喪失味覺或嗅覺',
    quarantine: '居家檢疫',
    soreThroat: '喉嚨痛、喉嚨癢',
  },
  CONTACT_SECTION: {
    hint: '可加入家人朋友，或是任何覺得有傳染疾病風險的接觸者。',
    title: '新增接觸者',
    label: '你接觸者的手機號碼',
    today: '今天',
    contactOfNDaysBefore: (n: number) => `${n} 天前的接觸者`,
    placeholder: '請輸入你接觸者的手機號碼',
    emptyWarning: '你必需提供你接觸者的手機號碼',
    invalidWarning: '你必需輸入合法的手機號碼',
  },
  STATISTIC_SECTION: {
    title: '今日統計',
    nLevelContacts: ['第一層內接觸者', '第二層內接觸者', '第三層內接觸者'],
    peopleUnit: '人',
  },
  BUTTON: {
    submit: '提交',
    login: '查看',
    loading: '載入中⋯',
    saving: '儲存中⋯',
    edit: '編輯',
    cancel: '取消',
    delete: '刪除',
    refreshContact: '刷新接觸時間',
  },
  ALERT: {
    loginFail: '錯誤：檢察網路連線或稍後再試',
    undefinedPhoneNumber: '錯誤：未定義的電話號碼',
  },
  DIALOG: {
    contact: '接觸者',
    lastContactDate: '上次接觸時間',
    contactRefresh: '如果你再次接觸了這個人，你可以刷新你們之間的接觸時間。',
    contactDelete: '刪除不小心加錯的人，實際接觸過的人無需刪除',
  },
};
